import { render } from "./SkillBadge.vue?vue&type=template&id=9bda1dae&scoped=true"
import script from "./SkillBadge.vue?vue&type=script&lang=js"
export * from "./SkillBadge.vue?vue&type=script&lang=js"

import "./SkillBadge.vue?vue&type=style&index=0&id=9bda1dae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bda1dae"]])

export default __exports__